import Pusher from 'pusher-js';
import { CONFIG } from './config';
const SocketUrl = CONFIG.SOCKET_URL

const wsPort = 6001;
const wssPort = 6001;
// const wsPort = 7778;
// const wssPort = 7778;

// window.Pusher = require("pusher-js");
const pusher = new Pusher("intranet", {
  wsHost: SocketUrl,
  wsPort,
  wssPort,
  disableStats: true,
  enabledTransports: ["ws", "wss"],
  encrypted: true,
  enableTLS: true,
  cluster:'mt1'
});

export default pusher;